const postcodeRegex =
  /^(([A-Z][A-Z]{0,1})([0-9][A-Z0-9]{0,1})) {0,}(([0-9])([A-Z]{2}))$/i;

const northernIrelandPostcodeRegex = /^BT.*/;

const onlyDigitsRegex = /^[0-9]*$/;
const nonDigitRegex = /[^\d.-]/g;
const passwordRegex = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])([\S\s]{8,})$/;

// https://github.com/utilitywarehouse/ordering-platform/blob/07f4bef4a379e48c58b22dae888fab11f3d28a97/services/order-submission-api/internal/api/api.go#L287
const mobileRegex = /^(07|\+44\s*7)\s*(?:\d\s*){8,9}$/;
const landlineRegex = /^(0[12]|\+44[12]|0044[12])\s*(?:\d\s*){8,9}$/;

// RFC 5322 3.4.1 - https://datatracker.ietf.org/doc/html/rfc5322#section-3.4.1
const emailRegex =
  /^([-!#-'*+/-9=?A-Z^-~]+(\.[-!#-'*+/-9=?A-Z^-~]+)*|"([]!#-[^-~ \t]|(\\[\t -~]))+")@([0-9a-zA-Z-]+(\.[0-9a-zA-Z-]+)+)$/;

const htmlTagRegEx = /<\/?[^>]+(>|$)/g;

const formatTel = (tel: string) => {
  return tel.replace('tel:', '').replace(/(\d{4})(\d{3})(\d{4})/, '$1 $2 $3');
};

const matchAnyCharactersOrHtmlTags = /(<[^>]*>.*?<\/[^>]*>)|(\s)|(\w)/g;

const customerNumberRegEx = /^[0-9]{6,7}$/;
const partnerNumberRegEx = /^([A-Z]{1,2}[0-9]{4,5}|[0-9]{5,6})$/;

const removeHtmlTag = (string: string) => string.replace(htmlTagRegEx, '');

const cleanNumericString = (string: string) => {
  return string.replace(/[^0-9.]/g, '');
};

export {
  postcodeRegex,
  northernIrelandPostcodeRegex,
  onlyDigitsRegex,
  nonDigitRegex,
  passwordRegex,
  emailRegex,
  mobileRegex,
  landlineRegex,
  formatTel,
  matchAnyCharactersOrHtmlTags,
  customerNumberRegEx,
  partnerNumberRegEx,
  cleanNumericString,
  removeHtmlTag,
};
